import React from 'react';
import { Label } from '@progress/kendo-react-labels';

const BaseLabel = ({ children, ...props }) => (
  <Label {...props}>
    {children}
  </Label>
);

export default BaseLabel;
